import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FiberManualRecord } from '@mui/icons-material';
import { ConnectionStatus } from '../../types';
import { ANIMATIONS, keyframes } from '../../styles';

interface StatusChipProps {
  statusLabel: string;
  displayStatus: ConnectionStatus;
}

const StatusChip: React.FC<StatusChipProps> = ({
  statusLabel,
  displayStatus,
}) => {
  const theme = useTheme();

  const getChipColor = () => {
    switch (displayStatus) {
      case 'connected':
        return 'success';
      case 'disconnected':
        return 'error';
      default:
        return 'warning';
    }
  };

  return (
    <Chip
      label={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography variant='caption' fontWeight='bold'>
            {statusLabel}
          </Typography>
          {displayStatus === 'connected' && (
            <FiberManualRecord
              sx={{
                fontSize: 8,
                color: theme.palette.success.main,
                animation: ANIMATIONS.PULSE,
              }}
            />
          )}
        </Box>
      }
      color={getChipColor()}
      size='small'
      variant='outlined'
      sx={{
        '& .MuiChip-icon': {
          animation:
            displayStatus === 'reconnecting'
              ? ANIMATIONS.PULSE_RECONNECT
              : 'none',
        },
        ...keyframes,
      }}
    />
  );
};

export default StatusChip;
